export const ACTION_PANEL_TABS = {
  listView: 'list-view',
  mapIcon: 'map-icon',
  filter: 'filter',
  legend: 'legend',
}
